import OrderDTO from "@/dto/order/OrderDTO";
import { useRequest } from "ahooks";
import { resync } from "@/services/api/orderSync";
import { message } from "antd";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import OrderStatus from "@/enum/OrderStatus";

const useSupplierBatchSyncOrders = () => {
    const { runAsync: handleSyncOrders, loading } = useRequest(
        async (orders: OrderDTO[]) => {
            const hide = message.loading("正在同步", 0);

            try {
                for (let i = 0; i < orders.length; i++) {
                    const order = orders[i];

                    /**
                     * FHY-2259
                     * 供货商视角下
                     * 是否为代理商已取消的并且是拆分订单
                     */
                    const isCancelAndRetailerSplitChildOrder =
                        order?.supplierDropShippingInfo?.retailerOrderMergeSplitStatus ===
                            OrderMergeSplitStatus.SPLIT_CHILD && order.status === OrderStatus.CANCELED;

                    // 跳过
                    if (isCancelAndRetailerSplitChildOrder) {
                        continue;
                    }

                    await resync(order.shopId, order, false);
                }

                message.success("同步成功");
            } finally {
                hide();
            }
        },
        { manual: true },
    );

    return { loading, handleSyncOrders };
};
export default useSupplierBatchSyncOrders;
